import template from './changePassword.html';

class ChangePasswordController {
    /*@ngInject*/
    constructor() {
        this.isBusy = false;
    }
}

export default {
    template: template,
    bindings: {
        message: '@'
    },
    controller: ChangePasswordController
};